import { ModalProps } from 'views/ProductPage/configurators/index';
import { ConfiguratorBase } from 'models/ConfiguratorBase';
import { IConstraint } from 'models/IConstraint';
import {
  maxValue,
  minMaxValue,
  minValue,
  required,
  rule,
  ValidationRule
} from 'components/Shared/Form';
import { ConstraintType } from 'models/ConstraintType';
import { Constraint, Max, Min, MinMax, Required } from 'models/Constraints';
import { rm } from 'utils';

interface UseConfigurator {
  configurator: ConfiguratorBase;
  setModal: ModalProps['setModal'];
}

export type Validate = (id: string, input: string, ...args: unknown[]) => IConstraint | undefined;
export interface ConstraintRules {
  [key: number]: (constraint: IConstraint, ...values: unknown[]) => ValidationRule;
}
type UserInput<TRule = Constraint> = TRule & { value: string };
const constraints: ConstraintRules = {
  [ConstraintType.MinMax]: ({ caption, min, max }: MinMax) =>
    rule(() => rm(caption, min, max), minMaxValue(min, max)),
  [ConstraintType.Min]: ({ caption, value }: UserInput<Min>, ...values) =>
    rule(() => rm(caption, value, ...values), minValue(parseFloat(value))),
  [ConstraintType.Max]: ({ caption, value }: UserInput<Max>, ...values) =>
    rule(() => rm(caption, value, ...values), maxValue(parseFloat(value))),
  [ConstraintType.Required]: ({ caption }: Required) => rule(() => rm(caption), required)
};

export const rules = (props: UseConfigurator) => {
  return function (id: string, input: string, ...args: string[]): IConstraint | undefined {
    const result = props.configurator.constraints
      .filter(c => c.attribute === id)
      .map(c => ({ result: constraints[c.rule](c, ...args)(input), ...c }))
      .find(r => Boolean(r.result));
    if (result) {
      props.setModal(result.result);
    }
    return result;
  };
};

type ConstraintValue = string | number;

export type ValueConstraint = IConstraint & { value: ConstraintValue };

export const isValueConstraint = (c?: IConstraint): c is ValueConstraint =>
  Boolean(c && 'value' in c);
